import { C34InlineMediaCardProps } from './C34InlineMediaCard.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from '@/shared/param-utils';
import { CtaInlineMediaCardProps } from '@ahc-digital/component-library';

export function CreateC34InlineMediaCardModel(props?: C34InlineMediaCardProps) {
  type t = CtaInlineMediaCardProps;
  const { fields, params } = props || {};
  const { renderRichText, renderImage, renderLink, renderText } = useConditionalRendering();

  return {
    cta: renderLink(fields?.CTA) ?? <></>,
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    image: renderImage(fields?.Image),
    icon: props?.fields?.Icon?.fields?.Value?.value as t['icon'],
    border: getCheckbox(params?.Border),
    hideAssetOnMobile: getCheckbox(params?.HideAssetOnMobile),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    elevation: getDroplink(params?.Elevation, 'elevation1'),
    iconSize: getDroplink(params?.IconSize, 'large'),
  };
}
